module.exports = __webpack_public_path__ + "img/palo-alto-networks.cfbb4886.webp";